import PiPopupWindowPreview from "../components/PiPopupWindowPreview";
import PiPopupHeaderBar from "../components/PiPopupHeaderBar";
import { InteractionType } from "../../../models/interactions/Interaction";
import LookatPreviewBody from "./LookatPreviewBody";

export default function LookatPreview() {
  return (
    <PiPopupWindowPreview
      size="fit"
      header={<PiPopupHeaderBar interactionType={InteractionType.Lookat} title="Look At" />}
      body={<LookatPreviewBody />}
    />
  );
}
